import React from "react";
import { Navbar, NavbarBrand } from "reactstrap";
import { Menu } from "antd";
import { NavLink as RouterNavLink } from "react-router-dom";

import routesService from "../service/routeService";
import UserBox from "./UserBox";

const MainNavbar = () => {
  const navbarItems = [
    { label: "Home", path: routesService.getHomePageRoute() },
  ];

  return (
    <div>
      <Navbar expand="md" className="py-0 shadow flex-nowrap">
        <NavbarBrand>
          <div className="d-flex align-items-center p-1">
            <img src={"/MetrixLab_logo.png"} alt="Logo" height="40" />
          </div>
        </NavbarBrand>
        <div className="ml-auto d-flex align-items-center">
          <Menu mode="horizontal" className="mr-3">
            {navbarItems.map(({ label, path }, navIndex) => (
              <Menu.Item key={`NAVBAR_ITEM_${navIndex}`} className="mx-0">
                <RouterNavLink
                  exact
                  className="nav-link"
                  activeClassName="active"
                  to={path}
                >
                  {label}
                </RouterNavLink>
              </Menu.Item>
            ))}
          </Menu>
          <UserBox />
        </div>
      </Navbar>
    </div>
  );
};

export default MainNavbar;
